<template>
  <div class="main-documentation ">
    <product-grid-item v-for="(itemGridBack, index) in 2" :key="itemGridBack[index]" :columns="2"
      :titleLabel="$t(`label.examsView.logos.${index + 1}.title`)"
      :subtitleLabel="$t(`label.examsView.logos.${index + 1}.subtitle`)" :imageLogo="urlsAndLogos[index + 1].img"
      :urlDoc="urlsAndLogos[index + 1].url" :numberPhotos="null" :urlYoutube="null"></product-grid-item>
    <product-grid-item v-for="(itemGridTop, index) in 2" :key="itemGridTop[index]" :columns="2"
      :titleLabel="$t(`label.examsView.logos.${index + 3}.title`)"
      :subtitleLabel="$t(`label.examsView.logos.${index + 3}.subtitle`)" :imageLogo="urlsAndLogos[index + 3].img"
      :urlDoc="urlsAndLogos[index + 3].url" :numberPhotos="null" :urlYoutube="null"></product-grid-item>
    <product-grid-item v-for="(itemGridTop, index) in 2" :key="itemGridTop[index]" :columns="2"
      :titleLabel="$t(`label.examsView.logos.${index + 5}.title`)"
      :subtitleLabel="$t(`label.examsView.logos.${index + 5}.subtitle`)" :imageLogo="urlsAndLogos[index + 5].img"
      :urlDoc="urlsAndLogos[index + 5].url" :numberPhotos="null" :urlYoutube="null"></product-grid-item>
    <product-grid-item v-for="(itemGridTop, index) in 2" :key="itemGridTop[index]" :columns="2"
      :titleLabel="$t(`label.examsView.logos.${index + 7}.title`)"
      :subtitleLabel="$t(`label.examsView.logos.${index + 7}.subtitle`)" :imageLogo="urlsAndLogos[index + 7].img"
      :urlDoc="urlsAndLogos[index + 7].url" :numberPhotos="null" :urlYoutube="null"></product-grid-item>
    <product-grid-item v-for="(itemGridTop, index) in 1" :key="itemGridTop[index]" :columns="2"
      :titleLabel="$t(`label.examsView.logos.${index + 8}.title`)"
      :subtitleLabel="$t(`label.examsView.logos.${index + 8}.subtitle`)" :imageLogo="urlsAndLogos[index + 8].img"
      :urlDoc="urlsAndLogos[index + 8].url" :numberPhotos="null" :urlYoutube="null"></product-grid-item>
  </div>
</template>

<script>
import ProductGridItem from "@/components/product-grid-item/ProductGridItem.vue";
import CONSTANTS from "./constants.js";
export default {
  name: "Exams",

  components: {
    ProductGridItem
  },
  computed: {
    columnsTop() {
      return 3;
    },
    columnsMiddle() {
      return 3;
    },
    columnsBack() {
      return 3;
    },
    urlsAndLogos() {
      return CONSTANTS.URLS_DOCS;
    }
  }
};
</script>

<style>
.main-documentation {
  margin-top: 300px;
  background: #fff;
}
</style>
